/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import {
  // ActivityColoredIcon,
  // ActivityIcon,
  BebopBWhite,
  Cloud,
  Note,
  TradeColoredIcon,
  TradeIcon,
} from "components/Icons";
import { BEBOP_ROUTES, NAV_LINKS } from "config/consts";
import { useDisplayOnClick } from "hooks/useDisplayOnClick";
import React from "react";
import { Theme } from "styles/theme";
import { NavbarButtons } from "./elements/NavbarButtons";
import { NavbarContainer } from "./elements/NavbarContainer";
import { NavbarLinks } from "./elements/NavbarLinks";
import { Profile } from "./elements/Profile";

export const NavbarV2Desktop = () => {
  const {
    isDisplayed: isProfileActionsDisplayed,
    toggleDisplay: onProfileClick,
    elementToClickRef: profileButtonRef,
    elementToDisplayRef: profileActionsRef,
    forceClose: closeProfileActions,
  } = useDisplayOnClick();

  return (
    <NavbarContainer>
      <NavbarContent>
        <Profile
          isDisplayed={isProfileActionsDisplayed}
          elementToClickRef={profileButtonRef as React.Ref<HTMLDivElement>}
          elementToDisplayRef={profileActionsRef as React.Ref<HTMLDivElement>}
          closeDisplay={closeProfileActions}
          onClick={onProfileClick}
        />

        <div>
          <NavbarButtons />
          <NavbarLinks closeProfileActions={closeProfileActions} />
        </div>
      </NavbarContent>
    </NavbarContainer>
  );
};

// Sub-components

const NavbarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;

// Helpers

export interface NavbarButtonOptions {
  symbol: {
    default: React.FC<React.SVGProps<SVGSVGElement>>;
    active: React.FC<React.SVGProps<SVGSVGElement>>;
  };
  text: string;
  colors?: { default?: string; hover?: string; active?: string; selected?: string };
  pathName?: string;
}

export const getNavbarButtonOptions = (theme: Theme): Array<NavbarButtonOptions> => [
  {
    symbol: { default: TradeIcon, active: TradeColoredIcon },
    text: "Trade",
    pathName: BEBOP_ROUTES.Trade,
    colors: {
      default: theme.font.primary.default,
      hover: theme["Colour ramps"].Green[600],
      active: theme["Colour ramps"].Green[500],
      selected: theme["Colour ramps"].Green[600],
    },
  },

  // {
  //   symbol: { default: ActivityIcon, active: ActivityColoredIcon },
  //   text: "Activity",
  //   pathName: BEBOP_ROUTES.Activity,
  //   colors: {
  //     default: theme.font.primary.default,
  //     hover: theme["Colour ramps"].Yellow[400],
  //     active: theme["Colour ramps"].Yellow[300],
  //     selected: theme["Colour ramps"].Yellow[500],
  //   },
  // },
];

export interface NavbarLinkItemOptions {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  text: string;
  to: string;
}

export const linkItems: Array<NavbarLinkItemOptions> = [
  {
    text: "FAQs",
    icon: Note,
    to: NAV_LINKS.FAQ,
  },
  {
    text: "API Docs",
    icon: Cloud,
    to: NAV_LINKS.DOCUMENTATION_API_INTRODUCTION,
  },
  {
    text: "About",
    icon: BebopBWhite,
    to: "/",
  },
];
